module.exports = "/virtual-football-league/img/amblems/left/logos/Burnley.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Burnley.png
// module id = 2061
// module chunks = 4